import { IconName } from '@purpur/library/icon';
import { InputType } from 'storybook/internal/csf';

import { ICONS_SVG_PATH, ICONS_SVG_VERSION } from '@telialt/assets/src/constants';
import { LocalIconName } from '@telialt/utils/src/@types/LocalIconName';
import { localIconNameList } from '@telialt/utils/src/@types/localIconNameList';
import { purpurIconList } from '@telialt/utils/src/@types/purpurIconList';
import { purpurIconNameList } from '@telialt/utils/src/@types/purpurIconNameList';

export const getLocalSvgIconString = (type: LocalIconName | string) => {
    const url = `${ICONS_SVG_PATH}?${ICONS_SVG_VERSION}#${type}`;

    return `
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor">
        <use xlink:href=${url} />
    </svg>
    `;
};

export const getLocalSvgIcon = (type: LocalIconName | string) => ({
    name: type,
    svg: getLocalSvgIconString(type),
});

export const getPurpurIcon = (type: IconName) => purpurIconList[type];

export const getSvgIcon = (type: IconName | LocalIconName | string) => {
    return getPurpurIcon(type as IconName) || getLocalSvgIcon(type as LocalIconName);
};

export const storybookIconListControl: InputType = {
    control: { type: 'select' },
    options: purpurIconNameList.concat(localIconNameList),
    defaultValue: 'pebble' as IconName | LocalIconName,
    name: 'select icon',
};
